import React, { Component } from 'react';

import WidgetLink from '../../../shared/components/WidgetLink';

import style from './ProviderCardHeader.scss';

class ProviderCardHeader extends Component {
  render() {
    const { provider, isOnWidget, toWidget, providerUrl, providerSpecialty } = this.props;

    return (
      <div className={style['provider-card-header']}>
        <figure className={style['provider-card-header__image']}>
          <WidgetLink href={providerUrl} isOnWidget={isOnWidget} toWidget={toWidget}>
            <img
              src={provider.profile.photo}
              srcSet={provider.profile.photo2x && `${provider.profile.photo2x} 2x`}
              alt={provider.display}
            />
          </WidgetLink>
        </figure>
        <div className={style['provider-card-header__content']}>
          <h4 className="font-size-md line-height-solid font-family-meta-bold text-ellipsis margin-none">
            <WidgetLink href={providerUrl} isOnWidget={isOnWidget} toWidget={toWidget}>
              {provider.display}
            </WidgetLink>
          </h4>
          {providerSpecialty && <p className="font-size-xs text-ellipsis">{providerSpecialty}</p>}
        </div>
      </div>
    );
  }
}

export default ProviderCardHeader;
